export default "__VITE_ASSET__0c03c6d8__"